export default {
  querySqpMainPage: '/courier-sqp-api/h5/v1/querySqpMainPage'
}
